import React, { ReactNode } from 'react';

import { useIsMobile, useStyles } from '@sravni/react-utils';

import { useIsMainPage } from '../../hooks/routes';
import { useWhitelabel } from '../../reducers/whitelabel';
import { TopSearch } from '../SearchBlock';

import styles from './overlay.module.scss';

interface IProps {
  children: ReactNode;
  active: boolean;
  toggleOverlay: (value: 'on' | 'off') => void;
}

export const Overlay = ({ children, active, toggleOverlay }: IProps) => {
  const isMainPage = useIsMainPage();
  const isWl = useWhitelabel();
  const isMobile = useIsMobile();
  const cx = useStyles(styles);

  return (
    <>
      {!isWl && isMainPage && isMobile && <TopSearch toggleOverlay={toggleOverlay} topBlockActive={active} />}
      <div className={styles.wrapper}>
        {children}
        <div className={cx('overlay', { overlayActive: active })} onClick={() => toggleOverlay('off')} />
      </div>
    </>
  );
};
